import { useCallback, useEffect, useState } from 'preact/hooks';
import useMultipleAdminAjax from './useMultipleAdminAjax';

import { getMatchCountForRangeFilterValue, getMatchCountForFilterValue, getUpdatedValue } from '../utils/filterHelpers';

/**
 * @param {object} args
 * @param {string=} args.fetchUrl
 * @returns {[[], [], { setFiltersWithPlotNumbers: (plotNumbers: []) => void, setFiltersActive: (active: boolean) => void, filtersLoaded: boolean, isFiltersActive: boolean, handleFilterChange: (name: string, value) => void, handleFilterReset: (name: string) => void, handleFiltersReset: () => void, loading: boolean, error: Error|null }]}
 */
export default function useFilters({ fetchUrl }) {
	const isFiltersActive = Boolean(fetchUrl);
	const [[fetchedFilters], { loading, error }] = useMultipleAdminAjax({ fetchUrls: [fetchUrl] });
	const [filters, setFilters] = useState([]);
	const [filterValues, setFilterValues] = useState([]);

	useEffect(() => {
		if (filters.length === 0) {
			return;
		}

		setFilterValues(filters.map(filter => ({
			name: filter.name,
			value: filter.defaultValue ? filter.choices.filter(choice => filter.defaultValue.indexOf(choice.value) >= 0).map(choice => choice.value) : null
		})));
	}, [filters]);

	const setFiltersWithPlotNumbers = useCallback(plotNumbers => {
		const emptyFilterValuesState = fetchedFilters.map(filter => ({
			name: filter.name,
			value: null
		}));

		setFilters(fetchedFilters.map(filter => ({
			...filter,
			choices: filter.choices.filter(choice => filter.type === 'range' ?
				getMatchCountForRangeFilterValue(plotNumbers, emptyFilterValuesState, filter.name, choice.value) :
				getMatchCountForFilterValue(plotNumbers, emptyFilterValuesState, filter.name, filter.type === 'checkbox' ? [choice.value] : choice.value))
		})));
	}, [fetchedFilters]);

	const handleFilterChange = useCallback((name, value) => {
		setFilterValues(filterValues.map(filter => ({
			...filter,
			value: filter.name === name ? getUpdatedValue(name, value, filter.value) : filter.value
		})));
	}, [filterValues]);

	const handleFilterReset = useCallback(name => {
		setFilterValues(filterValues.map(filter => ({
			...filter,
			value: filter.name === name ? null : filter.value
		})));
	}, [filterValues]);

	const handleFiltersReset = useCallback(() => {
		setFilterValues(filterValues.map(filter => ({
			...filter,
			value: null
		})));
	}, [filterValues]);

	return [filters, filterValues, { setFiltersWithPlotNumbers, filtersLoaded: Array.isArray(fetchedFilters), handleFilterChange, handleFilterReset, handleFiltersReset, isFiltersActive, loading, error }];
}
